import {
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { PlacesTableProps } from "../../helpers/types";
import { COLUMNS, thStyle } from "../../helpers/constants";
import PlaceRow from "./PlacesTable/PlaceRow";
import { useAuth } from "../../hooks/useAuth";

export default function PlacesTable({
  places,
  placesToBeDeletedList,
}: PlacesTableProps) {
  const { isAdmin } = useAuth();

  return (
    <div className="mt-3">
      <CTable responsive hover align="middle" className="mb-0">
        <CTableHead>
          <CTableRow>
            {isAdmin && <CTableHeaderCell style={{ ...thStyle, width: 44 }} />}
            {COLUMNS.map((col) => (
              <CTableHeaderCell
                key={col.key}
                scope="col"
                style={
                  "align" in col
                    ? { ...thStyle, textAlign: col.align }
                    : thStyle
                }
              >
                {col.label}
              </CTableHeaderCell>
            ))}
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {places?.map((place) => (
            <PlaceRow
              key={place?.id}
              place={place}
              deletedList={placesToBeDeletedList}
            />
          ))}
        </CTableBody>
      </CTable>
    </div>
  );
}
